var items = {
  "block.minecraft.air": "luft",
  "block.minecraft.stone": "stein",
  "block.minecraft.granite": "granitt",
  "block.minecraft.polished_granite": "finslipt granitt",
  "block.minecraft.diorite": "dioritt",
  "block.minecraft.polished_diorite": "finslipt dioritt",
  "block.minecraft.andesite": "andesitt",
  "block.minecraft.polished_andesite": "finslipt andesitt",
  "block.minecraft.grass_block": "gressblokk",
  "block.minecraft.dirt": "jord",
  "block.minecraft.coarse_dirt": "grov jord",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "karmosinnycel",
  "block.minecraft.warped_nylium": "forvridd nylium",
  "block.minecraft.cobblestone": "brostein",
  "block.minecraft.oak_planks": "eikeplanker",
  "block.minecraft.spruce_planks": "granplanker",
  "block.minecraft.birch_planks": "bjørkeplanker",
  "block.minecraft.jungle_planks": "jungeltreplanker",
  "block.minecraft.acacia_planks": "akasieplanker",
  "block.minecraft.dark_oak_planks": "mørkeikeplanker",
  "block.minecraft.crimson_planks": "karmosinplanker",
  "block.minecraft.warped_planks": "forvridde planker",
  "block.minecraft.oak_sapling": "eikespire",
  "block.minecraft.spruce_sapling": "granspire",
  "block.minecraft.birch_sapling": "bjørkespire",
  "block.minecraft.jungle_sapling": "jungeltrespire",
  "block.minecraft.acacia_sapling": "akasiespire",
  "block.minecraft.dark_oak_sapling": "mørkeikespire",
  "block.minecraft.bedrock": "grunnfjell",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "rød sand",
  "block.minecraft.gravel": "grus",
  "block.minecraft.gold_ore": "gullmalm",
  "block.minecraft.iron_ore": "jernmalm",
  "block.minecraft.coal_ore": "kullmalm",
  "block.minecraft.nether_gold_ore": "nethergullmalm",
  "block.minecraft.oak_log": "eiketømmer",
  "block.minecraft.spruce_log": "grantømmer",
  "block.minecraft.birch_log": "bjørketømmer",
  "block.minecraft.jungle_log": "jungeltretømmer",
  "block.minecraft.acacia_log": "akasietømmer",
  "block.minecraft.dark_oak_log": "mørkteiketømmer",
  "block.minecraft.crimson_stem": "karmosinstilk",
  "block.minecraft.warped_stem": "forvidd stilk",
  "block.minecraft.stripped_oak_log": "slindet eiketømmer",
  "block.minecraft.stripped_spruce_log": "slindet grantømmer",
  "block.minecraft.stripped_birch_log": "slindet bjørketømmer",
  "block.minecraft.stripped_jungle_log": "slindet jungeltretømmer",
  "block.minecraft.stripped_acacia_log": "slindet akasietømmer",
  "block.minecraft.stripped_dark_oak_log": "slindet mørkeiketømmer",
  "block.minecraft.stripped_crimson_stem": "slindet karmosinstilk",
  "block.minecraft.stripped_warped_stem": "slindet forvridd stilk",
  "block.minecraft.stripped_oak_wood": "slindet eiketre",
  "block.minecraft.stripped_spruce_wood": "slindet grantre",
  "block.minecraft.stripped_birch_wood": "slindet bjørketre",
  "block.minecraft.stripped_jungle_wood": "slindet jungeltre",
  "block.minecraft.stripped_acacia_wood": "slindet akasietre",
  "block.minecraft.stripped_dark_oak_wood": "slindet mørkeiketre",
  "block.minecraft.stripped_crimson_hyphae": "slindet karmosinhyfe",
  "block.minecraft.stripped_warped_hyphae": "slindet forvridd hyfe",
  "block.minecraft.oak_wood": "eiketre",
  "block.minecraft.spruce_wood": "grantre",
  "block.minecraft.birch_wood": "bjørketre",
  "block.minecraft.jungle_wood": "jungeltre",
  "block.minecraft.acacia_wood": "akasietre",
  "block.minecraft.dark_oak_wood": "mørkeiketre",
  "block.minecraft.crimson_hyphae": "karmosinhyfe",
  "block.minecraft.warped_hyphae": "forvridd hyfe",
  "block.minecraft.oak_leaves": "eikeløv",
  "block.minecraft.spruce_leaves": "granbar",
  "block.minecraft.birch_leaves": "bjørkeløv",
  "block.minecraft.jungle_leaves": "jungeltreløv",
  "block.minecraft.acacia_leaves": "akasieløv",
  "block.minecraft.dark_oak_leaves": "mørkeikeløv",
  "block.minecraft.sponge": "svamp",
  "block.minecraft.wet_sponge": "våt svamp",
  "block.minecraft.glass": "glass",
  "block.minecraft.lapis_ore": "lasursteinmalm",
  "block.minecraft.lapis_block": "lasursteinblokk",
  "block.minecraft.dispenser": "dispenser",
  "block.minecraft.sandstone": "sandstein",
  "block.minecraft.chiseled_sandstone": "uthugget sandstein",
  "block.minecraft.cut_sandstone": "skåret sandstein",
  "block.minecraft.note_block": "noteblokk",
  "block.minecraft.powered_rail": "redstonedrevet skinne",
  "block.minecraft.detector_rail": "detektorskinne",
  "block.minecraft.sticky_piston": "klebrig stempel",
  "block.minecraft.cobweb": "spindelvev",
  "block.minecraft.grass": "gress",
  "block.minecraft.fern": "bregne",
  "block.minecraft.dead_bush": "vissen busk",
  "block.minecraft.seagrass": "sjøgress",
  "block.minecraft.sea_pickle": "sjøagurk",
  "block.minecraft.piston": "stempel",
  "block.minecraft.white_wool": "hvit ull",
  "block.minecraft.orange_wool": "oransje ull",
  "block.minecraft.magenta_wool": "lyselilla ull",
  "block.minecraft.light_blue_wool": "lyseblå ull",
  "block.minecraft.yellow_wool": "gul ull",
  "block.minecraft.lime_wool": "limegrønn ull",
  "block.minecraft.pink_wool": "rosa ull",
  "block.minecraft.gray_wool": "grå ull",
  "block.minecraft.light_gray_wool": "lysegrå ull",
  "block.minecraft.cyan_wool": "turkis ull",
  "block.minecraft.purple_wool": "lilla ull",
  "block.minecraft.blue_wool": "blå ull",
  "block.minecraft.brown_wool": "brun ull",
  "block.minecraft.green_wool": "grønn ull",
  "block.minecraft.red_wool": "rød ull",
  "block.minecraft.black_wool": "svart ull",
  "block.minecraft.dandelion": "løvetann",
  "block.minecraft.poppy": "valmue",
  "block.minecraft.blue_orchid": "blå orkidé",
  "block.minecraft.allium": "prydløk",
  "block.minecraft.azure_bluet": "houstonia caerulea",
  "block.minecraft.red_tulip": "rød tulipan",
  "block.minecraft.orange_tulip": "oransje tulipan",
  "block.minecraft.white_tulip": "hvit tulipan",
  "block.minecraft.pink_tulip": "rosa tulipan",
  "block.minecraft.oxeye_daisy": "prestekrage",
  "block.minecraft.cornflower": "kornblomst",
  "block.minecraft.lily_of_the_valley": "liljekonvall",
  "block.minecraft.wither_rose": "wither-rose",
  "block.minecraft.brown_mushroom": "brun sopp",
  "block.minecraft.red_mushroom": "rød sopp",
  "block.minecraft.crimson_fungus": "karmosinsopp",
  "block.minecraft.warped_fungus": "forvridd sopp",
  "block.minecraft.crimson_roots": "karmosinrøtter",
  "block.minecraft.warped_roots": "forvridde røtter",
  "block.minecraft.nether_sprouts": "netherspirer",
  "block.minecraft.weeping_vines": "gråtende lianer",
  "block.minecraft.twisting_vines": "vridvin",
  "block.minecraft.sugar_cane": "sukkerrør",
  "block.minecraft.kelp": "tare",
  "block.minecraft.bamboo": "bambus",
  "block.minecraft.gold_block": "gullblokk",
  "block.minecraft.iron_block": "jernblokk",
  "block.minecraft.oak_slab": "eikehelle",
  "block.minecraft.spruce_slab": "granhelle",
  "block.minecraft.birch_slab": "bjørkehelle",
  "block.minecraft.jungle_slab": "jungeltrehelle",
  "block.minecraft.acacia_slab": "akasiehelle",
  "block.minecraft.dark_oak_slab": "mørkeikehelle",
  "block.minecraft.crimson_slab": "karmonsinhelle",
  "block.minecraft.warped_slab": "forvridd helle",
  "block.minecraft.stone_slab": "helle av stein",
  "block.minecraft.smooth_stone_slab": "helle av jevn stein",
  "block.minecraft.sandstone_slab": "helle av sandstein",
  "block.minecraft.cut_sandstone_slab": "helle av skåret sandstein",
  "block.minecraft.petrified_oak_slab": "helle av forsteinet eik",
  "block.minecraft.cobblestone_slab": "helle av brostein",
  "block.minecraft.brick_slab": "helle av tegl",
  "block.minecraft.stone_brick_slab": "helle av steinmur",
  "block.minecraft.nether_brick_slab": "helle av nethertegl",
  "block.minecraft.quartz_slab": "helle av kvarts",
  "block.minecraft.red_sandstone_slab": "helle av rød sandstein",
  "block.minecraft.cut_red_sandstone_slab": "helle av skåret rød sandstein",
  "block.minecraft.purpur_slab": "helle av purpur",
  "block.minecraft.prismarine_slab": "helle av prismarin",
  "block.minecraft.prismarine_brick_slab": "helle av prismarinmur",
  "block.minecraft.dark_prismarine_slab": "helle av mørk prismarin",
  "block.minecraft.smooth_quartz": "jevn kvartsblokk",
  "block.minecraft.smooth_red_sandstone": "jevn rød sandstein",
  "block.minecraft.smooth_sandstone": "jevn sandstein",
  "block.minecraft.smooth_stone": "jevn stein",
  "block.minecraft.bricks": "tegl",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "bokhylle",
  "block.minecraft.mossy_cobblestone": "mosete brostein",
  "block.minecraft.obsidian": "obsidian",
  "block.minecraft.torch": "fakkel",
  "block.minecraft.end_rod": "endestav",
  "block.minecraft.chorus_plant": "refrengplante",
  "block.minecraft.chorus_flower": "refrengblomst",
  "block.minecraft.purpur_block": "purpurblokk",
  "block.minecraft.purpur_pillar": "purpursøyle",
  "block.minecraft.purpur_stairs": "trapp av purpur",
  "block.minecraft.spawner": "fremkaller",
  "block.minecraft.oak_stairs": "eiketrapp",
  "block.minecraft.chest": "kiste",
  "block.minecraft.diamond_ore": "diamantmalm",
  "block.minecraft.diamond_block": "diamantblokk",
  "block.minecraft.crafting_table": "arbeidsbenk",
  "block.minecraft.farmland": "åkerland",
  "block.minecraft.furnace": "smelteovn",
  "block.minecraft.ladder": "stige",
  "block.minecraft.rail": "skinne",
  "block.minecraft.cobblestone_stairs": "trapp av brostein",
  "block.minecraft.lever": "spak",
  "block.minecraft.stone_pressure_plate": "steintrykkplate",
  "block.minecraft.oak_pressure_plate": "eiketrykkplate",
  "block.minecraft.spruce_pressure_plate": "grantrykkplate",
  "block.minecraft.birch_pressure_plate": "bjørketrykkplate",
  "block.minecraft.jungle_pressure_plate": "jungeltretrykkplate",
  "block.minecraft.acacia_pressure_plate": "akasietrykkplate",
  "block.minecraft.dark_oak_pressure_plate": "mørkeiketrykkplate",
  "block.minecraft.crimson_pressure_plate": "karmosintrykkplate",
  "block.minecraft.warped_pressure_plate": "forvridd trykkplate",
  "block.minecraft.polished_blackstone_pressure_plate": "trykkplate av finslipt svartstein",
  "block.minecraft.redstone_ore": "redstonemalm",
  "block.minecraft.redstone_torch": "redstonefakkel",
  "block.minecraft.snow": "snø",
  "block.minecraft.ice": "is",
  "block.minecraft.snow_block": "snøblokk",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "leire",
  "block.minecraft.jukebox": "platespiller",
  "block.minecraft.oak_fence": "eikegjerde",
  "block.minecraft.spruce_fence": "grangjerde",
  "block.minecraft.birch_fence": "bjørkegjerde",
  "block.minecraft.jungle_fence": "jungeltregjerde",
  "block.minecraft.acacia_fence": "akasiegjerde",
  "block.minecraft.dark_oak_fence": "mørkeikegjerde",
  "block.minecraft.crimson_fence": "karmosingjerde",
  "block.minecraft.warped_fence": "forvridd gjerde",
  "block.minecraft.pumpkin": "gresskar",
  "block.minecraft.carved_pumpkin": "utskåret gresskar",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "sjelesand",
  "block.minecraft.soul_soil": "sjelejord",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "finslipt basalt",
  "block.minecraft.soul_torch": "sjelefakkel",
  "block.minecraft.glowstone": "glødestein",
  "block.minecraft.jack_o_lantern": "gresskarlykt",
  "block.minecraft.oak_trapdoor": "eikefallem",
  "block.minecraft.spruce_trapdoor": "granfallem",
  "block.minecraft.birch_trapdoor": "bjørkefallem",
  "block.minecraft.jungle_trapdoor": "jungeltrefallem",
  "block.minecraft.acacia_trapdoor": "akasiefallem",
  "block.minecraft.dark_oak_trapdoor": "mørkeikefallem",
  "block.minecraft.crimson_trapdoor": "karmosinfallem",
  "block.minecraft.warped_trapdoor": "forvridd fallem",
  "block.minecraft.infested_stone": "befengt stein",
  "block.minecraft.infested_cobblestone": "befengt brostein",
  "block.minecraft.infested_stone_bricks": "befengt steinmur",
  "block.minecraft.infested_mossy_stone_bricks": "befengt mosete steinmur",
  "block.minecraft.infested_cracked_stone_bricks": "befengt sprukket steinmur",
  "block.minecraft.infested_chiseled_stone_bricks": "befengt uthugget steinmur",
  "block.minecraft.stone_bricks": "steinmur",
  "block.minecraft.mossy_stone_bricks": "mosete steinmur",
  "block.minecraft.cracked_stone_bricks": "sprukket steinmur",
  "block.minecraft.chiseled_stone_bricks": "uthugget steinmur",
  "block.minecraft.brown_mushroom_block": "brun soppblokk",
  "block.minecraft.red_mushroom_block": "rød soppblokk",
  "block.minecraft.mushroom_stem": "soppstilk",
  "block.minecraft.iron_bars": "jerngitter",
  "block.minecraft.chain": "kjetting",
  "block.minecraft.glass_pane": "glassrute",
  "block.minecraft.melon": "melon",
  "block.minecraft.vine": "ranke",
  "block.minecraft.oak_fence_gate": "eikegrind",
  "block.minecraft.spruce_fence_gate": "grangrind",
  "block.minecraft.birch_fence_gate": "bjørkegrind",
  "block.minecraft.jungle_fence_gate": "jungeltregrind",
  "block.minecraft.acacia_fence_gate": "akasiegrind",
  "block.minecraft.dark_oak_fence_gate": "mørkeikegrind",
  "block.minecraft.crimson_fence_gate": "karmosingrind",
  "block.minecraft.warped_fence_gate": "forvridd grind",
  "block.minecraft.brick_stairs": "trapp av tegl",
  "block.minecraft.stone_brick_stairs": "trapp av steinmur",
  "block.minecraft.mycelium": "mycel",
  "block.minecraft.lily_pad": "vannliljeblad",
  "block.minecraft.nether_bricks": "nethertegl",
  "block.minecraft.cracked_nether_bricks": "sprukket nethertegl",
  "block.minecraft.chiseled_nether_bricks": "uthugget nethertegl",
  "block.minecraft.nether_brick_fence": "gjerde av nethertegl",
  "block.minecraft.nether_brick_stairs": "trapp av nethertegl",
  "block.minecraft.enchanting_table": "trolldomsbord",
  "block.minecraft.end_portal_frame": "end-portalramme",
  "block.minecraft.end_stone": "endestein",
  "block.minecraft.end_stone_bricks": "endesteinmur",
  "block.minecraft.dragon_egg": "drageegg",
  "block.minecraft.redstone_lamp": "redstonelampe",
  "block.minecraft.sandstone_stairs": "trapp av sandstein",
  "block.minecraft.emerald_ore": "smaragdmalm",
  "block.minecraft.ender_chest": "enderkiste",
  "block.minecraft.tripwire_hook": "snubletrådkrok",
  "block.minecraft.emerald_block": "smaragdblokk",
  "block.minecraft.spruce_stairs": "grantrapp",
  "block.minecraft.birch_stairs": "bjørketrapp",
  "block.minecraft.jungle_stairs": "jungeltretrapp",
  "block.minecraft.crimson_stairs": "karmosintrapp",
  "block.minecraft.warped_stairs": "forvridde trapper",
  "block.minecraft.command_block": "kommandoblokk",
  "block.minecraft.beacon": "varde",
  "block.minecraft.cobblestone_wall": "mur av brostein",
  "block.minecraft.mossy_cobblestone_wall": "mur av mosete brostein",
  "block.minecraft.brick_wall": "mur av tegl",
  "block.minecraft.prismarine_wall": "mur av prismarin",
  "block.minecraft.red_sandstone_wall": "mur av rød sandstein",
  "block.minecraft.mossy_stone_brick_wall": "mur av mosete steinmur",
  "block.minecraft.granite_wall": "mur av granitt",
  "block.minecraft.stone_brick_wall": "mur av steinmur",
  "block.minecraft.nether_brick_wall": "mur av nethertegl",
  "block.minecraft.andesite_wall": "mur av andesitt",
  "block.minecraft.red_nether_brick_wall": "mur av rødt nethertegl",
  "block.minecraft.sandstone_wall": "mur av sandstein",
  "block.minecraft.end_stone_brick_wall": "mur av endesteinmur",
  "block.minecraft.diorite_wall": "mur av dioritt",
  "block.minecraft.blackstone_wall": "mur av svartstein",
  "block.minecraft.polished_blackstone_wall": "mur av finslipt svartstein",
  "block.minecraft.polished_blackstone_brick_wall": "mur av finslipt svartsteinsmur",
  "block.minecraft.stone_button": "steinknapp",
  "block.minecraft.oak_button": "eikeknapp",
  "block.minecraft.spruce_button": "granknapp",
  "block.minecraft.birch_button": "bjørkeknapp",
  "block.minecraft.jungle_button": "jungeltreknapp",
  "block.minecraft.acacia_button": "akasieknapp",
  "block.minecraft.dark_oak_button": "mørkeikeknapp",
  "block.minecraft.crimson_button": "karmosinknapp",
  "block.minecraft.warped_button": "forvridd knapp",
  "block.minecraft.polished_blackstone_button": "knapp av finslipt svartstein",
  "block.minecraft.anvil": "ambolt",
  "block.minecraft.chipped_anvil": "sprukket ambolt",
  "block.minecraft.damaged_anvil": "skadet ambolt",
  "block.minecraft.trapped_chest": "utløserkiste",
  "block.minecraft.light_weighted_pressure_plate": "lett tyngdetrykkplate",
  "block.minecraft.heavy_weighted_pressure_plate": "tung tyngdetrykkplate",
  "block.minecraft.daylight_detector": "dagslyssensor",
  "block.minecraft.redstone_block": "redstoneblokk",
  "block.minecraft.nether_quartz_ore": "netherkvarts-malm",
  "block.minecraft.hopper": "trakt",
  "block.minecraft.chiseled_quartz_block": "uthugget kvartsblokk",
  "block.minecraft.quartz_block": "kvartsblokk",
  "block.minecraft.quartz_bricks": "kvartsmur",
  "block.minecraft.quartz_pillar": "kvartssøyle",
  "block.minecraft.quartz_stairs": "trapp av kvarts",
  "block.minecraft.activator_rail": "aktiveringsskinne",
  "block.minecraft.dropper": "dropper",
  "block.minecraft.white_terracotta": "hvit terrakotta",
  "block.minecraft.orange_terracotta": "oransje terrakotta",
  "block.minecraft.magenta_terracotta": "lyselilla terrakotta",
  "block.minecraft.light_blue_terracotta": "lyseblå terrakotta",
  "block.minecraft.yellow_terracotta": "gul terrakotta",
  "block.minecraft.lime_terracotta": "limegrønn terrakotta",
  "block.minecraft.pink_terracotta": "rosa terrakotta",
  "block.minecraft.gray_terracotta": "grå terrakotta",
  "block.minecraft.light_gray_terracotta": "lysegrå terrakotta",
  "block.minecraft.cyan_terracotta": "turkis terrakotta",
  "block.minecraft.purple_terracotta": "lilla terrakotta",
  "block.minecraft.blue_terracotta": "blå terrakotta",
  "block.minecraft.brown_terracotta": "brun terrakotta",
  "block.minecraft.green_terracotta": "grønn terrakotta",
  "block.minecraft.red_terracotta": "rød terrakotta",
  "block.minecraft.black_terracotta": "svart terrakotta",
  "block.minecraft.barrier": "barriere",
  "block.minecraft.iron_trapdoor": "fallem av jern",
  "block.minecraft.hay_block": "høyball",
  "block.minecraft.white_carpet": "hvitt teppe",
  "block.minecraft.orange_carpet": "oransje teppe",
  "block.minecraft.magenta_carpet": "lyselilla teppe",
  "block.minecraft.light_blue_carpet": "lyseblått teppe",
  "block.minecraft.yellow_carpet": "gult teppe",
  "block.minecraft.lime_carpet": "limegrønt teppe",
  "block.minecraft.pink_carpet": "rosa teppe",
  "block.minecraft.gray_carpet": "grått teppe",
  "block.minecraft.light_gray_carpet": "lysegrått teppe",
  "block.minecraft.cyan_carpet": "turkist teppe",
  "block.minecraft.purple_carpet": "lilla teppe",
  "block.minecraft.blue_carpet": "blått teppe",
  "block.minecraft.brown_carpet": "brunt teppe",
  "block.minecraft.green_carpet": "grønt teppe",
  "block.minecraft.red_carpet": "rødt teppe",
  "block.minecraft.black_carpet": "svart teppe",
  "block.minecraft.terracotta": "terrakotta",
  "block.minecraft.coal_block": "kullblokk",
  "block.minecraft.packed_ice": "tettpakket is",
  "block.minecraft.acacia_stairs": "akasietrapp",
  "block.minecraft.dark_oak_stairs": "mørkeiketrapp",
  "block.minecraft.slime_block": "slimblokk",
  "block.minecraft.grass_path": "gressti",
  "block.minecraft.sunflower": "solsikke",
  "block.minecraft.lilac": "syrin",
  "block.minecraft.rose_bush": "rosebusk",
  "block.minecraft.peony": "peon",
  "block.minecraft.tall_grass": "høyt gress",
  "block.minecraft.large_fern": "stor bregne",
  "block.minecraft.white_stained_glass": "hvitfarget glass",
  "block.minecraft.orange_stained_glass": "oransjefarget glass",
  "block.minecraft.magenta_stained_glass": "lyselillafarget glass",
  "block.minecraft.light_blue_stained_glass": "lyseblåfarget glass",
  "block.minecraft.yellow_stained_glass": "gulfarget glass",
  "block.minecraft.lime_stained_glass": "limegrønnfarget glass",
  "block.minecraft.pink_stained_glass": "rosafarget glass",
  "block.minecraft.gray_stained_glass": "gråfarget glass",
  "block.minecraft.light_gray_stained_glass": "lysegråfarget glass",
  "block.minecraft.cyan_stained_glass": "turkisfarget glass",
  "block.minecraft.purple_stained_glass": "lillafarget glass",
  "block.minecraft.blue_stained_glass": "blåfarget glass",
  "block.minecraft.brown_stained_glass": "brunfarget glass",
  "block.minecraft.green_stained_glass": "grønnfarget glass",
  "block.minecraft.red_stained_glass": "rødfarget glass",
  "block.minecraft.black_stained_glass": "svartfarget glass",
  "block.minecraft.white_stained_glass_pane": "hvitfarget glassrute",
  "block.minecraft.orange_stained_glass_pane": "oransjefarget glassrute",
  "block.minecraft.magenta_stained_glass_pane": "lyselillafarget glassrute",
  "block.minecraft.light_blue_stained_glass_pane": "lyseblåfarget glassrute",
  "block.minecraft.yellow_stained_glass_pane": "gulfarget glassrute",
  "block.minecraft.lime_stained_glass_pane": "limegrønnfarget glassrute",
  "block.minecraft.pink_stained_glass_pane": "rosafarget glassrute",
  "block.minecraft.gray_stained_glass_pane": "gråfarget glassrute",
  "block.minecraft.light_gray_stained_glass_pane": "lysegråfarget glassrute",
  "block.minecraft.cyan_stained_glass_pane": "turkisfarget glassrute",
  "block.minecraft.purple_stained_glass_pane": "lillafarget glassrute",
  "block.minecraft.blue_stained_glass_pane": "blåfarget glassrute",
  "block.minecraft.brown_stained_glass_pane": "brunfarget glassrute",
  "block.minecraft.green_stained_glass_pane": "grønnfarget glassrute",
  "block.minecraft.red_stained_glass_pane": "rødfarget glassrute",
  "block.minecraft.black_stained_glass_pane": "svartfarget glassrute",
  "block.minecraft.prismarine": "prismarin",
  "block.minecraft.prismarine_bricks": "prismarinmur",
  "block.minecraft.dark_prismarine": "mørk prismarin",
  "block.minecraft.prismarine_stairs": "trapp av prismarin",
  "block.minecraft.prismarine_brick_stairs": "trapp av prismarinmur",
  "block.minecraft.dark_prismarine_stairs": "trapp av mørk prismarin",
  "block.minecraft.sea_lantern": "sjølanterne",
  "block.minecraft.red_sandstone": "rød sandstein",
  "block.minecraft.chiseled_red_sandstone": "uthugget rød sandstein",
  "block.minecraft.cut_red_sandstone": "skåret rød sandstein",
  "block.minecraft.red_sandstone_stairs": "trapp av rød sandstein",
  "block.minecraft.repeating_command_block": "repeterende kommandoblokk",
  "block.minecraft.chain_command_block": "kjede-kommandoblokk",
  "block.minecraft.magma_block": "magmablokk",
  "block.minecraft.nether_wart_block": "nethervorteblokk",
  "block.minecraft.warped_wart_block": "forvridd vorteblokk",
  "block.minecraft.red_nether_bricks": "rødt nethertegl",
  "block.minecraft.bone_block": "beinblokk",
  "block.minecraft.structure_void": "struktur-tomrom",
  "block.minecraft.observer": "observatør",
  "block.minecraft.shulker_box": "shulkerboks",
  "block.minecraft.white_shulker_box": "hvit shulkerboks",
  "block.minecraft.orange_shulker_box": "oransje shulkerboks",
  "block.minecraft.magenta_shulker_box": "lyselilla shulkerboks",
  "block.minecraft.light_blue_shulker_box": "lyseblå shulkerboks",
  "block.minecraft.yellow_shulker_box": "gul shulkerboks",
  "block.minecraft.lime_shulker_box": "limegrønn shulkerboks",
  "block.minecraft.pink_shulker_box": "rosa shulkerboks",
  "block.minecraft.gray_shulker_box": "grå shulkerboks",
  "block.minecraft.light_gray_shulker_box": "lysegrå shulkerboks",
  "block.minecraft.cyan_shulker_box": "turkis shulkerboks",
  "block.minecraft.purple_shulker_box": "lilla shulkerboks",
  "block.minecraft.blue_shulker_box": "blå shulkerboks",
  "block.minecraft.brown_shulker_box": "brun shulkerboks",
  "block.minecraft.green_shulker_box": "grønn shulkerboks",
  "block.minecraft.red_shulker_box": "rød shulkerboks",
  "block.minecraft.black_shulker_box": "svart shulkerboks",
  "block.minecraft.white_glazed_terracotta": "hvit glasert terrakotta",
  "block.minecraft.orange_glazed_terracotta": "oransje glasert terrakotta",
  "block.minecraft.magenta_glazed_terracotta": "lyselilla glasert terrakotta",
  "block.minecraft.light_blue_glazed_terracotta": "lyseblå glasert terrakotta",
  "block.minecraft.yellow_glazed_terracotta": "gul glasert terrakotta",
  "block.minecraft.lime_glazed_terracotta": "limegrønn glasert terrakotta",
  "block.minecraft.pink_glazed_terracotta": "rosa glasert terrakotta",
  "block.minecraft.gray_glazed_terracotta": "grå glasert terrakotta",
  "block.minecraft.light_gray_glazed_terracotta": "lysegrå glasert terrakotta",
  "block.minecraft.cyan_glazed_terracotta": "turkis glasert terrakotta",
  "block.minecraft.purple_glazed_terracotta": "lilla glasert terrakotta",
  "block.minecraft.blue_glazed_terracotta": "blå glasert terrakotta",
  "block.minecraft.brown_glazed_terracotta": "brun glasert terrakotta",
  "block.minecraft.green_glazed_terracotta": "grønn glasert terrakotta",
  "block.minecraft.red_glazed_terracotta": "rød glasert terrakotta",
  "block.minecraft.black_glazed_terracotta": "svart glasert terrakotta",
  "block.minecraft.white_concrete": "hvit betong",
  "block.minecraft.orange_concrete": "oransje betong",
  "block.minecraft.magenta_concrete": "lyselilla betong",
  "block.minecraft.light_blue_concrete": "lyseblå betong",
  "block.minecraft.yellow_concrete": "gul betong",
  "block.minecraft.lime_concrete": "limegrønn betong",
  "block.minecraft.pink_concrete": "rosa betong",
  "block.minecraft.gray_concrete": "grå betong",
  "block.minecraft.light_gray_concrete": "lysegrå betong",
  "block.minecraft.cyan_concrete": "turkis betong",
  "block.minecraft.purple_concrete": "lilla betong",
  "block.minecraft.blue_concrete": "blå betong",
  "block.minecraft.brown_concrete": "brun betong",
  "block.minecraft.green_concrete": "grønn betong",
  "block.minecraft.red_concrete": "rød betong",
  "block.minecraft.black_concrete": "svart betong",
  "block.minecraft.white_concrete_powder": "hvit sement",
  "block.minecraft.orange_concrete_powder": "oransje sement",
  "block.minecraft.magenta_concrete_powder": "lyselilla sement",
  "block.minecraft.light_blue_concrete_powder": "lyseblå sement",
  "block.minecraft.yellow_concrete_powder": "gul sement",
  "block.minecraft.lime_concrete_powder": "limegrønn sement",
  "block.minecraft.pink_concrete_powder": "rosa sement",
  "block.minecraft.gray_concrete_powder": "grå sement",
  "block.minecraft.light_gray_concrete_powder": "lysegrå sement",
  "block.minecraft.cyan_concrete_powder": "blågrønn sement",
  "block.minecraft.purple_concrete_powder": "lilla sement",
  "block.minecraft.blue_concrete_powder": "blå sement",
  "block.minecraft.brown_concrete_powder": "brun sement",
  "block.minecraft.green_concrete_powder": "grønn sement",
  "block.minecraft.red_concrete_powder": "rød sement",
  "block.minecraft.black_concrete_powder": "svart sement",
  "block.minecraft.turtle_egg": "skilpaddeegg",
  "block.minecraft.dead_tube_coral_block": "død orgelkorallblokk",
  "block.minecraft.dead_brain_coral_block": "død hjernekorallblokk",
  "block.minecraft.dead_bubble_coral_block": "død boblekorallblokk",
  "block.minecraft.dead_fire_coral_block": "død ildkorallblokk",
  "block.minecraft.dead_horn_coral_block": "død hornkorallblokk",
  "block.minecraft.tube_coral_block": "orgelkorallblokk",
  "block.minecraft.brain_coral_block": "hjernekorallblokk",
  "block.minecraft.bubble_coral_block": "boblekorallblokk",
  "block.minecraft.fire_coral_block": "ildkorallblokk",
  "block.minecraft.horn_coral_block": "hornkorallblokk",
  "block.minecraft.tube_coral": "orgelkorall",
  "block.minecraft.brain_coral": "hjernekorall",
  "block.minecraft.bubble_coral": "boblekorall",
  "block.minecraft.fire_coral": "ildkorall",
  "block.minecraft.horn_coral": "hornkorall",
  "block.minecraft.dead_brain_coral": "død hjernekorall",
  "block.minecraft.dead_bubble_coral": "død boblekorall",
  "block.minecraft.dead_fire_coral": "død ildkorall",
  "block.minecraft.dead_horn_coral": "død hornkorall",
  "block.minecraft.dead_tube_coral": "død orgelkorall",
  "block.minecraft.tube_coral_fan": "orgelkorallvifte",
  "block.minecraft.brain_coral_fan": "hjernekorallvifte",
  "block.minecraft.bubble_coral_fan": "boblekorallvifte",
  "block.minecraft.fire_coral_fan": "ildkorallvifte",
  "block.minecraft.horn_coral_fan": "hornkorallvifte",
  "block.minecraft.dead_tube_coral_fan": "død orgelkorallvifte",
  "block.minecraft.dead_brain_coral_fan": "død hjernekorallvifte",
  "block.minecraft.dead_bubble_coral_fan": "død boblekorallvifte",
  "block.minecraft.dead_fire_coral_fan": "død ildkorallvifte",
  "block.minecraft.dead_horn_coral_fan": "død hornkorallvifte",
  "block.minecraft.blue_ice": "blåis",
  "block.minecraft.conduit": "fløder",
  "block.minecraft.polished_granite_stairs": "trapp av finslipt granitt",
  "block.minecraft.smooth_red_sandstone_stairs": "trapp av jevn rød sandstein",
  "block.minecraft.mossy_stone_brick_stairs": "trapp av mosete steinmur",
  "block.minecraft.polished_diorite_stairs": "trapp av finslipt dioritt",
  "block.minecraft.mossy_cobblestone_stairs": "trapp av mosete brostein",
  "block.minecraft.end_stone_brick_stairs": "trapp av endesteinsmur",
  "block.minecraft.stone_stairs": "trapp av stein",
  "block.minecraft.smooth_sandstone_stairs": "trapp av jevn sandstein",
  "block.minecraft.smooth_quartz_stairs": "trapp av jevn kvarts",
  "block.minecraft.granite_stairs": "trapp av granitt",
  "block.minecraft.andesite_stairs": "trapp av andesitt",
  "block.minecraft.red_nether_brick_stairs": "trapp av rødt nethertegl",
  "block.minecraft.polished_andesite_stairs": "trapp av finslipt andesitt",
  "block.minecraft.diorite_stairs": "trapp av dioritt",
  "block.minecraft.polished_granite_slab": "helle av finslipt granitt",
  "block.minecraft.smooth_red_sandstone_slab": "helle av jevn rød sandstein",
  "block.minecraft.mossy_stone_brick_slab": "helle av mosete steinmur",
  "block.minecraft.polished_diorite_slab": "helle av finslipt dioritt",
  "block.minecraft.mossy_cobblestone_slab": "helle av mosete brostein",
  "block.minecraft.end_stone_brick_slab": "helle av endesteinsmur",
  "block.minecraft.smooth_sandstone_slab": "helle av jevn sandstein",
  "block.minecraft.smooth_quartz_slab": "helle av jevn kvarts",
  "block.minecraft.granite_slab": "helle av granitt",
  "block.minecraft.andesite_slab": "helle av andesitt",
  "block.minecraft.red_nether_brick_slab": "helle av rødt nethertegl",
  "block.minecraft.polished_andesite_slab": "helle av finslipt andesitt",
  "block.minecraft.diorite_slab": "helle av dioritt",
  "block.minecraft.scaffolding": "stillas",
  "block.minecraft.iron_door": "jerndør",
  "block.minecraft.oak_door": "eikedør",
  "block.minecraft.spruce_door": "grandør",
  "block.minecraft.birch_door": "bjørkedør",
  "block.minecraft.jungle_door": "jungeltredør",
  "block.minecraft.acacia_door": "akasiedør",
  "block.minecraft.dark_oak_door": "mørkeikedør",
  "block.minecraft.crimson_door": "karmosindør",
  "block.minecraft.warped_door": "forvridd dør",
  "block.minecraft.repeater": "redstoneforsterker",
  "block.minecraft.comparator": "redstonesammenligner",
  "block.minecraft.structure_block": "strukturblokk",
  "block.minecraft.jigsaw": "pusleblokk",
  "item.minecraft.turtle_helmet": "skilpaddeskall□□på hodet:□+2 rustning",
  "item.minecraft.scute": "skjell",
  "item.minecraft.iron_shovel": "jernspade□□i hovedhånd:□+3.5 angrepsstyrke□-3 angrepshastighet",
  "item.minecraft.iron_pickaxe": "jernhakke□□i hovedhånd:□+3 angrepsstyrke□-2.8 angrepshastighet",
  "item.minecraft.iron_axe": "jernøks□□i hovedhånd:□+8 angrepsstyrke□-3.1 angrepshastighet",
  "item.minecraft.flint_and_steel": "tennstål",
  "item.minecraft.apple": "eple",
  "item.minecraft.bow": "bue",
  "item.minecraft.arrow": "pil",
  "item.minecraft.coal": "kull",
  "item.minecraft.charcoal": "trekull",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "jernbarre",
  "item.minecraft.gold_ingot": "gullbarre",
  "item.minecraft.netherite_ingot": "netherittbarre",
  "item.minecraft.netherite_scrap": "netherittskrap",
  "item.minecraft.iron_sword": "jernsverd□□i hovedhånd:□+5 angrepsstyrke□-2.4 angrepshastighet",
  "item.minecraft.wooden_sword": "tresverd□□i hovedhånd:□+3 angrepsstyrke□-2.4 angrepshastighet",
  "item.minecraft.wooden_shovel": "trespade□□i hovedhånd:□+1.5 angrepsstyrke□-3 angrepshastighet",
  "item.minecraft.wooden_pickaxe": "trehakke□□i hovedhånd:□+1 angrepsstyrke□-2.8 angrepshastighet",
  "item.minecraft.wooden_axe": "treøks□□i hovedhånd:□+6 angrepsstyrke□-3.2 angrepshastighet",
  "item.minecraft.stone_sword": "steinsverd□□i hovedhånd:□+4 angrepsstyrke□-2.4 angrepshastighet",
  "item.minecraft.stone_shovel": "steinspade□□i hovedhånd:□+2.5 angrepsstyrke□-3 angrepshastighet",
  "item.minecraft.stone_pickaxe": "steinhakke□□i hovedhånd:□+2 angrepsstyrke□-2.8 angrepshastighet",
  "item.minecraft.stone_axe": "steinøks□□i hovedhånd:□+8 angrepsstyrke□-3.2 angrepshastighet",
  "item.minecraft.diamond_sword": "diamantsverd□□i hovedhånd:□+6 angrepsstyrke□-2.4 angrepshastighet",
  "item.minecraft.diamond_shovel": "diamantspade□□i hovedhånd:□+4.5 angrepsstyrke□-3 angrepshastighet",
  "item.minecraft.diamond_pickaxe": "diamanthakke□□i hovedhånd:□+4 angrepsstyrke□-2.8 angrepshastighet",
  "item.minecraft.diamond_axe": "diamantøks□□i hovedhånd:□+8 angrepsstyrke□-3 angrepshastighet",
  "item.minecraft.stick": "pinne",
  "item.minecraft.bowl": "bolle",
  "item.minecraft.mushroom_stew": "soppstuing",
  "item.minecraft.golden_sword": "gullsverd□□i hovedhånd:□+3 angrepsstyrke□-2.4 angrepshastighet",
  "item.minecraft.golden_shovel": "gullspade□□i hovedhånd:□+1.5 angrepsstyrke□-3 angrepshastighet",
  "item.minecraft.golden_pickaxe": "gullhakke□□i hovedhånd:□+1 angrepsstyrke□-2.8 angrepshastighet",
  "item.minecraft.golden_axe": "gulløks□□i hovedhånd:□+6 angrepsstyrke□-3 angrepshastighet",
  "item.minecraft.netherite_sword": "netherittsverd□□i hovedhånd:□+7 angrepsstyrke□-2.4 angrepshastighet",
  "item.minecraft.netherite_shovel": "netherittspade□□i hovedhånd:□+5.5 angrepsstyrke□-3 angrepshastighet",
  "item.minecraft.netherite_pickaxe": "netheritthakke□□i hovedhånd:□+5 angrepsstyrke□-2.8 angrepshastighet",
  "item.minecraft.netherite_axe": "netherittøks□□i hovedhånd:□+9 angrepsstyrke□-3 angrepshastighet",
  "item.minecraft.string": "tråd",
  "item.minecraft.feather": "fjær",
  "item.minecraft.gunpowder": "krutt",
  "item.minecraft.wooden_hoe": "tregrev□□i hovedhånd:□-3 angrepshastighet",
  "item.minecraft.stone_hoe": "steingrev□□i hovedhånd:□-2 angrepshastighet",
  "item.minecraft.iron_hoe": "jerngrev□□i hovedhånd:□-1 angrepshastighet",
  "item.minecraft.diamond_hoe": "diamantgrev□□i hovedhånd:",
  "item.minecraft.golden_hoe": "gullgrev□□i hovedhånd:□-3 angrepshastighet",
  "item.minecraft.netherite_hoe": "netherittgrev□□i hovedhånd:",
  "item.minecraft.wheat_seeds": "hvetefrø",
  "item.minecraft.wheat": "hvete",
  "item.minecraft.bread": "brød",
  "item.minecraft.leather_helmet": "lærhette□□på hodet:□+1 rustning",
  "item.minecraft.leather_chestplate": "lærtrøye□□på overkroppen:□+3 rustning",
  "item.minecraft.leather_leggings": "lærbukser□□på bena:□+2 rustning",
  "item.minecraft.leather_boots": "lærstøvler□□på føttene:□+1 rustning",
  "item.minecraft.chainmail_helmet": "brynjehette□□på hodet:□+2 rustning",
  "item.minecraft.chainmail_chestplate": "ringbrynje□□på overkroppen:□+5 rustning",
  "item.minecraft.chainmail_leggings": "brynjehose□□på bena:□+4 rustning",
  "item.minecraft.chainmail_boots": "brynjestøvler□□på føttene:□+1 rustning",
  "item.minecraft.iron_helmet": "jernhjelm□□på hodet:□+2 rustning",
  "item.minecraft.iron_chestplate": "jernbrystplate□□på overkroppen:□+6 rustning",
  "item.minecraft.iron_leggings": "jernbenplater□□på bena:□+5 rustning",
  "item.minecraft.iron_boots": "jernstøvler□□på føttene:□+2 rustning",
  "item.minecraft.diamond_helmet": "diamanthjelm□□på hodet:□+3 rustning□+2 rustningshardhet",
  "item.minecraft.diamond_chestplate": "diamantbrystplate□□på overkroppen:□+8 rustning□+2 rustningshardhet",
  "item.minecraft.diamond_leggings": "diamantbenplater□□på bena:□+6 rustning□+2 rustningshardhet",
  "item.minecraft.diamond_boots": "diamantstøvler□□på føttene:□+3 rustning□+2 rustningshardhet",
  "item.minecraft.golden_helmet": "gullhjelm□□på hodet:□+2 rustning",
  "item.minecraft.golden_chestplate": "gullbrystplate□□på overkroppen:□+5 rustning",
  "item.minecraft.golden_leggings": "gullbenplater□□på bena:□+3 rustning",
  "item.minecraft.golden_boots": "gullstøvler□□på føttene:□+1 rustning",
  "item.minecraft.netherite_helmet": "netheritthjelm□□på hodet:□+3 rustning□+3 rustningshardhet□+1 tilbakeslagsmotstand",
  "item.minecraft.netherite_chestplate": "netherittbrystplate□□på overkroppen:□+8 rustning□+3 rustningshardhet□+1 tilbakeslagsmotstand",
  "item.minecraft.netherite_leggings": "netherittbenplater□□på bena:□+6 rustning□+3 rustningshardhet□+1 tilbakeslagsmotstand",
  "item.minecraft.netherite_boots": "netherittstøvler□□på føttene:□+3 rustning□+3 rustningshardhet□+1 tilbakeslagsmotstand",
  "item.minecraft.flint": "flint",
  "item.minecraft.porkchop": "rå svinekotelett",
  "item.minecraft.cooked_porkchop": "stekt svinekotelett",
  "item.minecraft.painting": "maleri",
  "item.minecraft.golden_apple": "gulleple",
  "item.minecraft.enchanted_golden_apple": "fortryllet gulleple",
  "block.minecraft.oak_sign": "eikeskilt",
  "block.minecraft.spruce_sign": "granskilt",
  "block.minecraft.birch_sign": "bjørkeskilt",
  "block.minecraft.jungle_sign": "jungeltreskilt",
  "block.minecraft.acacia_sign": "akasieskilt",
  "block.minecraft.dark_oak_sign": "mørkeikeskilt",
  "block.minecraft.crimson_sign": "karmosinskilt",
  "block.minecraft.warped_sign": "forvridd skilt",
  "item.minecraft.bucket": "bøtte",
  "item.minecraft.water_bucket": "vannbøtte",
  "item.minecraft.lava_bucket": "lavabøtte",
  "item.minecraft.minecart": "gruvevogn",
  "item.minecraft.saddle": "sal",
  "item.minecraft.redstone": "redstonepulver",
  "item.minecraft.snowball": "snøball",
  "item.minecraft.oak_boat": "eikebåt",
  "item.minecraft.leather": "lær",
  "item.minecraft.milk_bucket": "melkebøtte",
  "item.minecraft.pufferfish_bucket": "kulefiskebøtte",
  "item.minecraft.salmon_bucket": "laksebøtte",
  "item.minecraft.cod_bucket": "torskebøtte",
  "item.minecraft.tropical_fish_bucket": "sydhavsfiskebøtte",
  "item.minecraft.brick": "teglstein",
  "item.minecraft.clay_ball": "leireball",
  "block.minecraft.dried_kelp_block": "tørket tareblokk",
  "item.minecraft.paper": "papir",
  "item.minecraft.book": "bok",
  "item.minecraft.slime_ball": "slimball",
  "item.minecraft.chest_minecart": "gruvevogn med kiste",
  "item.minecraft.furnace_minecart": "dampdrevet gruvevogn",
  "item.minecraft.egg": "egg",
  "item.minecraft.compass": "kompass",
  "item.minecraft.fishing_rod": "fiskestang",
  "item.minecraft.clock": "klokke",
  "item.minecraft.glowstone_dust": "glødesteinspulver",
  "item.minecraft.cod": "rå torsk",
  "item.minecraft.salmon": "rå laks",
  "item.minecraft.tropical_fish": "sydhavsfisk",
  "item.minecraft.pufferfish": "kulefisk",
  "item.minecraft.cooked_cod": "stekt torsk",
  "item.minecraft.cooked_salmon": "stekt laks",
  "item.minecraft.ink_sac": "blekksekk",
  "item.minecraft.red_dye": "rødt fargestoff",
  "item.minecraft.green_dye": "grønt fargestoff",
  "item.minecraft.cocoa_beans": "kakaobønner",
  "item.minecraft.lapis_lazuli": "lasurstein",
  "item.minecraft.purple_dye": "lilla fargestoff",
  "item.minecraft.cyan_dye": "turkist fargestoff",
  "item.minecraft.light_gray_dye": "lysegrått fargestoff",
  "item.minecraft.gray_dye": "grått fargestoff",
  "item.minecraft.pink_dye": "rosa fargestoff",
  "item.minecraft.lime_dye": "limegrønt fargestoff",
  "item.minecraft.yellow_dye": "gult fargestoff",
  "item.minecraft.light_blue_dye": "lyseblått fargestoff",
  "item.minecraft.magenta_dye": "lyselilla fargestoff",
  "item.minecraft.orange_dye": "oransje fargestoff",
  "item.minecraft.bone_meal": "beinmel",
  "item.minecraft.blue_dye": "blått fargestoff",
  "item.minecraft.brown_dye": "brunt fargestoff",
  "item.minecraft.black_dye": "svart fargestoff",
  "item.minecraft.white_dye": "hvitt fargestoff",
  "item.minecraft.bone": "bein",
  "item.minecraft.sugar": "sukker",
  "block.minecraft.cake": "kake",
  "block.minecraft.white_bed": "hvit seng",
  "block.minecraft.orange_bed": "oransje seng",
  "block.minecraft.magenta_bed": "lyselilla seng",
  "block.minecraft.light_blue_bed": "lyseblå seng",
  "block.minecraft.yellow_bed": "gul seng",
  "block.minecraft.lime_bed": "limegrønn seng",
  "block.minecraft.pink_bed": "rosa seng",
  "block.minecraft.gray_bed": "grå seng",
  "block.minecraft.light_gray_bed": "lysegrå seng",
  "block.minecraft.cyan_bed": "turkis seng",
  "block.minecraft.purple_bed": "lilla seng",
  "block.minecraft.blue_bed": "blå seng",
  "block.minecraft.brown_bed": "brun seng",
  "block.minecraft.green_bed": "grønn seng",
  "block.minecraft.red_bed": "rød seng",
  "block.minecraft.black_bed": "svart seng",
  "item.minecraft.cookie": "kjeks",
  "item.minecraft.filled_map": "kart□#0",
  "item.minecraft.shears": "saks",
  "item.minecraft.melon_slice": "melonbåt",
  "item.minecraft.dried_kelp": "tørket tare",
  "item.minecraft.pumpkin_seeds": "gresskarfrø",
  "item.minecraft.melon_seeds": "melonfrø",
  "item.minecraft.beef": "rå biff",
  "item.minecraft.cooked_beef": "stekt biff",
  "item.minecraft.chicken": "rå kylling",
  "item.minecraft.cooked_chicken": "stekt kylling",
  "item.minecraft.rotten_flesh": "råttent kjøtt",
  "item.minecraft.ender_pearl": "enderperle",
  "item.minecraft.blaze_rod": "flammestav",
  "item.minecraft.ghast_tear": "ghasttåre",
  "item.minecraft.gold_nugget": "gullklump",
  "item.minecraft.nether_wart": "nethervorte",
  "item.minecraft.potion": "ubryggelig brygg□ingen effekter",
  "item.minecraft.glass_bottle": "glassflaske",
  "item.minecraft.spider_eye": "edderkoppøye",
  "item.minecraft.fermented_spider_eye": "gjæret edderkoppøye",
  "item.minecraft.blaze_powder": "flammepulver",
  "item.minecraft.magma_cream": "magmakrem",
  "block.minecraft.brewing_stand": "bryggestativ",
  "block.minecraft.cauldron": "gryte",
  "item.minecraft.ender_eye": "enderøye",
  "item.minecraft.glistering_melon_slice": "glitrende melonbåt",
  "item.minecraft.bat_spawn_egg": "fremkallingsegg for flaggermus",
  "item.minecraft.bee_spawn_egg": "fremkallingsegg for bie",
  "item.minecraft.blaze_spawn_egg": "fremkallingsegg for flammeskrømt",
  "item.minecraft.cat_spawn_egg": "fremkallingsegg for katt",
  "item.minecraft.cave_spider_spawn_egg": "fremkallingsegg for huleedderkopp",
  "item.minecraft.chicken_spawn_egg": "fremkallingsegg for høne",
  "item.minecraft.cod_spawn_egg": "fremkallingsegg for torsk",
  "item.minecraft.cow_spawn_egg": "fremkallingsegg for ku",
  "item.minecraft.creeper_spawn_egg": "fremkallingsegg for creeper",
  "item.minecraft.dolphin_spawn_egg": "fremkallingsegg for delfin",
  "item.minecraft.donkey_spawn_egg": "fremkallingsegg for esel",
  "item.minecraft.drowned_spawn_egg": "fremkallingsegg for draug",
  "item.minecraft.elder_guardian_spawn_egg": "fremkallingsegg for gammel vokter",
  "item.minecraft.enderman_spawn_egg": "fremkallingsegg for endermann",
  "item.minecraft.endermite_spawn_egg": "fremkallingsegg for endermidd",
  "item.minecraft.evoker_spawn_egg": "fremkallingsegg for åndemaner",
  "item.minecraft.fox_spawn_egg": "fremkallingsegg for rev",
  "item.minecraft.ghast_spawn_egg": "fremkallingsegg for ghast",
  "item.minecraft.guardian_spawn_egg": "fremkallingsegg for vokter",
  "item.minecraft.hoglin_spawn_egg": "fremkallingsegg for hoglin",
  "item.minecraft.horse_spawn_egg": "fremkallingsegg for hest",
  "item.minecraft.husk_spawn_egg": "fremkallingsegg for ørkenzombie",
  "item.minecraft.llama_spawn_egg": "fremkallingsegg for lama",
  "item.minecraft.magma_cube_spawn_egg": "fremkallingsegg for magmakube",
  "item.minecraft.mooshroom_spawn_egg": "fremkallingsegg for mooshroom",
  "item.minecraft.mule_spawn_egg": "fremkallingsegg for muldyr",
  "item.minecraft.ocelot_spawn_egg": "fremkallingsegg for ozelot",
  "item.minecraft.panda_spawn_egg": "fremkallingsegg for panda",
  "item.minecraft.parrot_spawn_egg": "fremkallingsegg for papegøye",
  "item.minecraft.phantom_spawn_egg": "fremkallingsegg for fantom",
  "item.minecraft.pig_spawn_egg": "fremkallingsegg for gris",
  "item.minecraft.piglin_spawn_egg": "fremkallingsegg for piglin",
  "item.minecraft.pillager_spawn_egg": "fremkallingsegg for plyndrer",
  "item.minecraft.polar_bear_spawn_egg": "fremkallingsegg for isbjørn",
  "item.minecraft.pufferfish_spawn_egg": "fremkallingsegg for kulefisk",
  "item.minecraft.rabbit_spawn_egg": "fremkallingsegg for kanin",
  "item.minecraft.ravager_spawn_egg": "fremkallingsegg for herjer",
  "item.minecraft.salmon_spawn_egg": "fremkallingsegg for laks",
  "item.minecraft.sheep_spawn_egg": "fremkallingsegg for sau",
  "item.minecraft.shulker_spawn_egg": "fremkallingsegg for shulker",
  "item.minecraft.silverfish_spawn_egg": "fremkallingsegg for sølvkre",
  "item.minecraft.skeleton_spawn_egg": "fremkallingsegg for skjelett",
  "item.minecraft.skeleton_horse_spawn_egg": "fremkallingsegg for skjeletthest",
  "item.minecraft.slime_spawn_egg": "fremkallingsegg for slim",
  "item.minecraft.spider_spawn_egg": "fremkallingsegg for edderkopp",
  "item.minecraft.squid_spawn_egg": "fremkallingsegg for blekksprut",
  "item.minecraft.stray_spawn_egg": "fremkallingsegg for vandrer",
  "item.minecraft.strider_spawn_egg": "fremkmallingsegg for lavavandrer",
  "item.minecraft.trader_llama_spawn_egg": "fremkallingsegg for handelslama",
  "item.minecraft.tropical_fish_spawn_egg": "fremkallingsegg for sydhavsfisk",
  "item.minecraft.turtle_spawn_egg": "fremkallingsegg for skilpadde",
  "item.minecraft.vex_spawn_egg": "fremkallingsegg for plageånd",
  "item.minecraft.villager_spawn_egg": "fremkallingsegg for bygding",
  "item.minecraft.vindicator_spawn_egg": "fremkallingsegg for forsvarer",
  "item.minecraft.wandering_trader_spawn_egg": "fremkallingsegg for omvandrende handelsmann",
  "item.minecraft.witch_spawn_egg": "fremkallingsegg for heks",
  "item.minecraft.wither_skeleton_spawn_egg": "fremkallingsegg for witherskjelett",
  "item.minecraft.wolf_spawn_egg": "fremkallingsegg for ulv",
  "item.minecraft.zoglin_spawn_egg": "fremkallingsegg for zoglin",
  "item.minecraft.zombie_spawn_egg": "fremkallingsegg for zombie",
  "item.minecraft.zombie_horse_spawn_egg": "fremkallingsegg for zombiehest",
  "item.minecraft.zombie_villager_spawn_egg": "fremkallingsegg for zombiebygding",
  "item.minecraft.zombified_piglin_spawn_egg": "fremkallingsegg for zombiepiglin",
  "item.minecraft.experience_bottle": "fortryllelsesflaske",
  "item.minecraft.fire_charge": "ildladning",
  "item.minecraft.writable_book": "bok og fjærpenn",
  "item.minecraft.written_book": "skrevet bok",
  "item.minecraft.emerald": "smaragd",
  "item.minecraft.item_frame": "ramme",
  "block.minecraft.flower_pot": "blomsterpotte",
  "item.minecraft.carrot": "gulrot",
  "item.minecraft.potato": "potet",
  "item.minecraft.baked_potato": "bakt potet",
  "item.minecraft.poisonous_potato": "giftig potet",
  "item.minecraft.map": "blankt kart",
  "item.minecraft.golden_carrot": "gullrot",
  "block.minecraft.skeleton_skull": "skjelettskalle",
  "block.minecraft.wither_skeleton_skull": "witherskjelettskalle",
  "block.minecraft.player_head": "spillerhode",
  "block.minecraft.zombie_head": "zombiehode",
  "block.minecraft.creeper_head": "creeperhode",
  "block.minecraft.dragon_head": "dragehode",
  "item.minecraft.carrot_on_a_stick": "gulrot på pinne",
  "item.minecraft.warped_fungus_on_a_stick": "forvridd sopp på en pinne",
  "item.minecraft.nether_star": "netherstjerne",
  "item.minecraft.pumpkin_pie": "gresskarpai",
  "item.minecraft.firework_rocket": "fyrverkeri",
  "item.minecraft.firework_star": "fyrverkeristjerne",
  "item.minecraft.enchanted_book": "fortryllet bok",
  "item.minecraft.nether_brick": "netherteglstein",
  "item.minecraft.quartz": "netherkvarts",
  "item.minecraft.tnt_minecart": "gruvevogn med tnt",
  "item.minecraft.hopper_minecart": "gruvevogn med trakt",
  "item.minecraft.prismarine_shard": "prismarinskår",
  "item.minecraft.prismarine_crystals": "prismarinkrystaller",
  "item.minecraft.rabbit": "rå kanin",
  "item.minecraft.cooked_rabbit": "stekt kanin",
  "item.minecraft.rabbit_stew": "kaninlapskaus",
  "item.minecraft.rabbit_foot": "kaninlabb",
  "item.minecraft.rabbit_hide": "kaninskinn",
  "item.minecraft.armor_stand": "rustningsstativ",
  "item.minecraft.iron_horse_armor": "jernhesterustning",
  "item.minecraft.golden_horse_armor": "gullhesterustning",
  "item.minecraft.diamond_horse_armor": "diamanthesterustning",
  "item.minecraft.leather_horse_armor": "lærhesterustning",
  "item.minecraft.lead": "tau",
  "item.minecraft.name_tag": "navnelapp",
  "item.minecraft.command_block_minecart": "gruvevogn med kommandoblokk",
  "item.minecraft.mutton": "rått fårekjøtt",
  "item.minecraft.cooked_mutton": "stekt fårekjøtt",
  "block.minecraft.white_banner": "hvitt banner",
  "block.minecraft.orange_banner": "oransje banner",
  "block.minecraft.magenta_banner": "lyselilla banner",
  "block.minecraft.light_blue_banner": "lyseblått banner",
  "block.minecraft.yellow_banner": "gult banner",
  "block.minecraft.lime_banner": "limegrønt banner",
  "block.minecraft.pink_banner": "rosa banner",
  "block.minecraft.gray_banner": "grått banner",
  "block.minecraft.light_gray_banner": "lysegrått banner",
  "block.minecraft.cyan_banner": "turkist banner",
  "block.minecraft.purple_banner": "lilla banner",
  "block.minecraft.blue_banner": "blått banner",
  "block.minecraft.brown_banner": "brunt banner",
  "block.minecraft.green_banner": "grønt banner",
  "block.minecraft.red_banner": "rødt banner",
  "block.minecraft.black_banner": "svart banner",
  "item.minecraft.end_crystal": "end-krystall",
  "item.minecraft.chorus_fruit": "refrengfrukt",
  "item.minecraft.popped_chorus_fruit": "åpnet refrengfrukt",
  "item.minecraft.beetroot": "rødbete",
  "item.minecraft.beetroot_seeds": "rødbetefrø",
  "item.minecraft.beetroot_soup": "rødbetesuppe",
  "item.minecraft.dragon_breath": "dragens ånde",
  "item.minecraft.splash_potion": "ubryggbart kastebrygg□ingen effekter",
  "item.minecraft.spectral_arrow": "spektralpil",
  "item.minecraft.tipped_arrow": "uproduserbar dyppet pil□ingen effekter",
  "item.minecraft.lingering_potion": "vedvarende ubryggbart brygg□ingen effekter",
  "item.minecraft.shield": "skjold",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "granbåt",
  "item.minecraft.birch_boat": "bjørkebåt",
  "item.minecraft.jungle_boat": "jungeltrebåt",
  "item.minecraft.acacia_boat": "akasiebåt",
  "item.minecraft.dark_oak_boat": "mørkeikebåt",
  "item.minecraft.totem_of_undying": "udødelighetstotem",
  "item.minecraft.shulker_shell": "shulkerskjell",
  "item.minecraft.iron_nugget": "jernklump",
  "item.minecraft.knowledge_book": "kunnskapsbok",
  "item.minecraft.debug_stick": "feilsøkingspinne",
  "item.minecraft.music_disc_13": "musikkplate□c418 - 13",
  "item.minecraft.music_disc_cat": "musikkplate□c418 - cat",
  "item.minecraft.music_disc_blocks": "musikkplate□c418 - blocks",
  "item.minecraft.music_disc_chirp": "musikkplate□c418 - chirp",
  "item.minecraft.music_disc_far": "musikkplate□c418 - far",
  "item.minecraft.music_disc_mall": "musikkplate□c418 - mall",
  "item.minecraft.music_disc_mellohi": "musikkplate□c418 - mellohi",
  "item.minecraft.music_disc_stal": "musikkplate□c418 - stal",
  "item.minecraft.music_disc_strad": "musikkplate□c418 - strad",
  "item.minecraft.music_disc_ward": "musikkplate□c418 - ward",
  "item.minecraft.music_disc_11": "musikkplate□c418 - 11",
  "item.minecraft.music_disc_wait": "musikkplate□c418 - wait",
  "item.minecraft.music_disc_pigstep": "musikkplate□lena raine - pigstep",
  "item.minecraft.trident": "trefork□□i hovedhånd:□+8 angrepsstyrke□-2.9 angrepshastighet",
  "item.minecraft.phantom_membrane": "fantomhinne",
  "item.minecraft.nautilus_shell": "perlebåtskall",
  "item.minecraft.heart_of_the_sea": "havets hjerte",
  "item.minecraft.crossbow": "armbrøst",
  "item.minecraft.suspicious_stew": "mistenkelig stuing",
  "block.minecraft.loom": "vevstol",
  "item.minecraft.flower_banner_pattern": "bannermønster□blomst",
  "item.minecraft.creeper_banner_pattern": "bannermønster□creeper",
  "item.minecraft.skull_banner_pattern": "bannermønster□hodeskalle",
  "item.minecraft.mojang_banner_pattern": "bannermønster□ting",
  "item.minecraft.globe_banner_pattern": "bannermønster□globus",
  "item.minecraft.piglin_banner_pattern": "bannermønster□snute",
  "block.minecraft.composter": "kompostbinge",
  "block.minecraft.barrel": "tønne",
  "block.minecraft.smoker": "røykovn",
  "block.minecraft.blast_furnace": "masovn",
  "block.minecraft.cartography_table": "kartografibenk",
  "block.minecraft.fletching_table": "pilmakerbenk",
  "block.minecraft.grindstone": "slipestein",
  "block.minecraft.lectern": "lesepult",
  "block.minecraft.smithing_table": "smibenk",
  "block.minecraft.stonecutter": "steinkutter",
  "block.minecraft.bell": "bjelle",
  "block.minecraft.lantern": "lykt",
  "block.minecraft.soul_lantern": "sjelelykt",
  "item.minecraft.sweet_berries": "søtbær",
  "block.minecraft.campfire": "bål",
  "block.minecraft.soul_campfire": "sjelebål",
  "block.minecraft.shroomlight": "lampinjong",
  "item.minecraft.honeycomb": "bikake",
  "block.minecraft.bee_nest": "biebol",
  "block.minecraft.beehive": "bikube",
  "item.minecraft.honey_bottle": "honningflaske",
  "block.minecraft.honey_block": "honningblokk",
  "block.minecraft.honeycomb_block": "bikakeblokk",
  "block.minecraft.lodestone": "leidarstein",
  "block.minecraft.netherite_block": "netherittblokk",
  "block.minecraft.ancient_debris": "eldgammelt skrap",
  "block.minecraft.target": "blink",
  "block.minecraft.crying_obsidian": "gråtende obsidian",
  "block.minecraft.blackstone": "svartstein",
  "block.minecraft.blackstone_slab": "helle av svartstein",
  "block.minecraft.blackstone_stairs": "trapp av svartstein",
  "block.minecraft.gilded_blackstone": "forgyllet svartstein",
  "block.minecraft.polished_blackstone": "finslipt svartstein",
  "block.minecraft.polished_blackstone_slab": "helle av finslipt svartstein",
  "block.minecraft.polished_blackstone_stairs": "trapp av finslipt svartstein",
  "block.minecraft.chiseled_polished_blackstone": "uthugget finslipt svartstein",
  "block.minecraft.polished_blackstone_bricks": "finslipt svartsteinsmur",
  "block.minecraft.polished_blackstone_brick_slab": "helle av finslipt svartsteinsmur",
  "block.minecraft.polished_blackstone_brick_stairs": "trapp av finslipt svartsteinsmur",
  "block.minecraft.cracked_polished_blackstone_bricks": "sprukket finslipt svartsteinsmur",
  "block.minecraft.respawn_anchor": "livsanker",
}
export const no_no = items; 
